import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { LayoutDashboard, GraduationCap, Wallet, Users, Calculator, Bot, Award, Landmark, LogOut, Menu, ShieldCheck } from 'lucide-react';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/academy', label: 'Academy', icon: GraduationCap },
  { to: '/practice', label: 'Practice', icon: Landmark },
  { to: '/referral', label: 'Referral', icon: Users },
  { to: '/wallet', label: 'Wallet', icon: Wallet },
  { to: '/calculator', label: 'Kalkulator', icon: Calculator },
  { to: '/tutor', label: 'AI Gold Tutor', icon: Bot },
  { to: '/certificate', label: 'Sertifikat', icon: Award },
];

const NavLinks = ({ onClick }) => {
  const loc = useLocation();
  return (
    <nav className="flex flex-col gap-1">
      {navItems.map((it) => {
        const Icon = it.icon;
        const active = loc.pathname === it.to;
        return (
          <Link key={it.to} to={it.to} onClick={onClick} data-testid={`nav-${it.to.slice(1)}`}
            className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${active ? 'bg-[hsl(var(--brand-gold)/0.15)] text-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`}>
            <Icon className="h-4 w-4" />{it.label}
          </Link>
        );
      })}
    </nav>
  );
};

export const MemberLayout = ({ children }) => {
  const { user, logout, isAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <div className="flex">
        <aside className="hidden lg:flex w-64 flex-col border-r bg-card min-h-screen sticky top-0 p-4">
          <Link to="/dashboard" className="flex items-center gap-2 px-2 py-3 mb-2">
            <div className="h-8 w-8 rounded-lg bg-[hsl(var(--brand-gold))] flex items-center justify-center font-display font-bold text-[hsl(var(--brand-ink))]">G</div>
            <span className="font-display font-bold text-sm leading-tight">Gold Trading<br/>Academy</span>
          </Link>
          <NavLinks />
          <div className="mt-auto pt-4 border-t">
            {isAdmin && (
              <Button variant="outline" className="w-full mb-2 justify-start" onClick={() => navigate('/admin')} data-testid="nav-admin">
                <ShieldCheck className="h-4 w-4 mr-2" />Admin Panel
              </Button>
            )}
            <div className="px-2 py-2 text-xs text-muted-foreground">{user?.name}<br/>{user?.email}</div>
            <Button variant="ghost" className="w-full justify-start" onClick={logout} data-testid="logout-button">
              <LogOut className="h-4 w-4 mr-2" />Keluar
            </Button>
          </div>
        </aside>

        <div className="flex-1 min-w-0">
          <header className="lg:hidden flex items-center justify-between border-b bg-card px-4 py-3 sticky top-0 z-20">
            <Link to="/dashboard" className="flex items-center gap-2">
              <div className="h-7 w-7 rounded-lg bg-[hsl(var(--brand-gold))] flex items-center justify-center font-display font-bold text-[hsl(var(--brand-ink))] text-sm">G</div>
              <span className="font-display font-bold text-sm">Gold Trading Academy</span>
            </Link>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild><Button variant="ghost" size="icon" data-testid="mobile-menu-button"><Menu className="h-5 w-5" /></Button></SheetTrigger>
              <SheetContent side="left" className="w-72">
                <div className="mt-6"><NavLinks onClick={() => setOpen(false)} />
                  {isAdmin && <Button variant="outline" className="w-full mt-2 justify-start" onClick={() => { setOpen(false); navigate('/admin'); }}><ShieldCheck className="h-4 w-4 mr-2" />Admin Panel</Button>}
                  <Button variant="ghost" className="w-full mt-4 justify-start" onClick={logout}><LogOut className="h-4 w-4 mr-2" />Keluar</Button>
                </div>
              </SheetContent>
            </Sheet>
          </header>
          <main className="p-4 sm:p-6 lg:p-8 max-w-[1200px] mx-auto">{children}</main>
        </div>
      </div>
    </div>
  );
};

export default MemberLayout;
